import * as React from 'react';

import Image from 'lib/image-container';
import { useDetectPrint } from 'lib/use-detect-print';
import { MediaQueryWidth } from 'lib/use-media-query';
import useScrollbarWidth from 'lib/use-scrollbar-width';

import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import {
  COLUMNS_GAP_MEDIUM,
  IMAGE_MAX_WIDTH_1,
  PAGE_PADDING_LARGE,
  PAGE_PADDING_MEDIUM,
  PAGE_PADDING_SMALL,
} from 'components/page/sections';

import { getPropsSectionThreeContainer } from './section-three-container.props';

export const SectionThreeContainer: React.FC = () => {
  const props = getPropsSectionThreeContainer();
  const scrollbarWidth = useScrollbarWidth(true);
  const isPrinting = useDetectPrint();
  return (
    <>
      <PageSection extraClass="section-cta" padding="top" inner={true} color="transparent">
        <CtaBox align="start">
          <CtaBoxText>{props.sections.one.intro}</CtaBoxText>
        </CtaBox>
      </PageSection>
      <PageSection extraClass="section-cta" padding="block" inner={true} color="transparent">
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={ColumnsSize['1/2']} verticalAlign="stretch">
            <CtaBox align="start">
              <CtaBoxHeader tag="h2">
                {props.sections.one.titleElement}
                <br />
              </CtaBoxHeader>
            </CtaBox>
          </ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']} verticalAlign="stretch"></ColumnsItem>
        </Columns>
        <Columns hasMobileLayout={true} vAlignTop={true}>
          <ColumnsItem size={ColumnsSize['1/2']} verticalAlign="stretch">
            <CtaBox align="start">
              <CtaBoxText>{props.sections.one.column1}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']} dir="vertical">
            <CtaBox align="start">
              <CtaBoxText>{props.sections.one.column2}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
        </Columns>
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={ColumnsSize['1/2']} verticalAlign="stretch"></ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']} dir="vertical">
            <GoodToKnow
              color="primary"
              title={props.sections.one.goodToKnow.title}
              content={props.sections.one.goodToKnow.content}
            />
          </ColumnsItem>
        </Columns>
      </PageSection>
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          {isPrinting ? null : (
            <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/3']}>
              <Image
                width={375}
                height={812}
                style={{
                  objectFit: 'contain',
                  objectPosition: props.sections.two.imageObjectPosition,
                }}
                quality={75}
                src={props.sections.two.imageSrc}
                alt=""
                sizes={`
                    (max-width: ${MediaQueryWidth['desktop-sm']}px) calc(100vw - 2 * ${PAGE_PADDING_SMALL} - ${scrollbarWidth}),
                    (max-width: ${MediaQueryWidth['tablet-lg']}px) calc((100vw - 2 * ${PAGE_PADDING_MEDIUM} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                    (max-width: ${MediaQueryWidth['content-max']}px) calc((100vw - 2 * ${PAGE_PADDING_LARGE} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                    ${IMAGE_MAX_WIDTH_1}
                `}
              />
            </ColumnsItem>
          )}

          <ColumnsItem size={isPrinting ? ColumnsSize['1/1'] : ColumnsSize['2/3']} dir="vertical">
            <CtaBox align="start">
              <CtaBoxHeader tag="h2">{props.sections.two.titleElement}</CtaBoxHeader>
              <CtaBoxText>{props.sections.two.text}</CtaBoxText>
            </CtaBox>
            <br />
            <CtaBox align="start">
              <CtaBoxHeader tag="h3">{props.sections.two.subTitle}</CtaBoxHeader>
              <CtaBoxText>{props.sections.two.text2}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
        </Columns>
      </PageSection>
    </>
  );
};
